import { isShopify, type Platform } from '../context/env-context';

const SHOPIFY_PRICE_LIST_SLUG = 'spark-shopify-price';
const SHOPIFY_COMPARE_AT_PRICE_LIST_SLUG = 'spark-shopify-compare-at-price';

export const SHOPIFY_PRICE_LISTS = [
  SHOPIFY_PRICE_LIST_SLUG,
  SHOPIFY_COMPARE_AT_PRICE_LIST_SLUG,
] as const;

export const SHOPIFY_ADMIN_FALLBACK_URL = 'https://admin.shopify.com';

// This is the contextual save bar in shopify, used in dash and shopify app
export const SAVE_BAR_ID = 'save-bar';

// NOTE: this date and conditions are only for BFS review and will be removed once we get the badge
const BFS_REVIEW_SUBMISSION_DATE = new Date('2026-08-18T14:00:00Z');

export function isAfterBFSReviewSubmission(platform?: string, installedAt?: string | Date) {
  if (!isShopify(platform as Platform | undefined) || !installedAt) {
    return false;
  }

  const installedAtTime = new Date(installedAt).getTime();
  if (Number.isNaN(installedAtTime)) {
    return false;
  }

  return installedAtTime >= BFS_REVIEW_SUBMISSION_DATE.getTime();
}
